module.exports = __webpack_public_path__ + "img/googlePlayBg.919bd944.png";